import { render } from "./Permisos.vue?vue&type=template&id=707d9fc5&scoped=true"
import script from "./Permisos.vue?vue&type=script&lang=js"
export * from "./Permisos.vue?vue&type=script&lang=js"

import "./Permisos.vue?vue&type=style&index=0&id=707d9fc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707d9fc5"]])

export default __exports__